import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { CustomCursor } from './ui/CustomCursor';
import { HeroSphere } from './ui/HeroSphere';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-[#09090B]" data-id="element-50">
      <CustomCursor data-id="element-51" />

      {/* Fixed sphere background — always visible, sections scroll over it */}
      <div className="fixed inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden" data-id="element-52">
        <HeroSphere size={550} className="hidden md:flex opacity-60" data-id="element-53" />
        <HeroSphere size={350} className="flex md:hidden opacity-40" data-id="element-54" />
      </div>

      <Navigation data-id="element-55" />
      {/* Clip wrapper only around content BELOW the hero to prevent horizontal overflow
            without breaking sticky inside VideoHero */}
      <main className="flex-1 pt-20 relative z-[1]" data-id="element-56">{children}</main>
      <Footer data-id="element-57" />
    </div>;
}